import type { Dispatch } from 'redux';

import { getLocale } from '../../../../configuration';
import { isUserSessionExpired } from '../../../../configuration/login/selectors';
import type { State } from '../../../../reducers';
import { fetchLatestPositionOfAsset } from '../../../api/api';
import { apiCallActions } from '../../../api/redux/api.redux';
import { ErrorCauses } from '../../../api/redux/types';
import type { LatestPosition } from '../../../api/types';
import { getDrivingTimeDisplayItems, getSelectedDrivingTimesRowId } from '../../../realtime/redux/realtime.redux';
import { realtimeSidebarActions } from '../../redux/detailsSidebar.redux';

export const fetchLatestPositionThunk =
    () =>
    (dispatch: Dispatch, getState: () => State): void => {
        const activeRowId = getSelectedDrivingTimesRowId(getState());
        const drivingTimesItem = getDrivingTimeDisplayItems(getState()).find(item => item.id === activeRowId);

        if (drivingTimesItem) {
            if (isUserSessionExpired(getState())) {
                dispatch(apiCallActions.setErrorForApiCall({ type: ErrorCauses.SESSION_EXPIRED_FETCH, value: true }));
                return;
            }

            const requests = [
                fetchLatestPositionOfAsset(drivingTimesItem.assetId, getLocale(getState())),
            ] as Promise<LatestPosition>[];
            Promise.all(requests)
                .then(result => {
                    const latestPosition = result[0];
                    dispatch(realtimeSidebarActions.fetchedLastPosition(latestPosition));

                    dispatch(
                        apiCallActions.setErrorForApiCall({ type: ErrorCauses.LATEST_POSITION_FETCH, value: false })
                    );
                    dispatch(
                        apiCallActions.setErrorForApiCall({ type: ErrorCauses.SESSION_EXPIRED_FETCH, value: false })
                    );
                })
                .catch(() => {
                    dispatch(
                        apiCallActions.setErrorForApiCall({ type: ErrorCauses.LATEST_POSITION_FETCH, value: true })
                    );
                });
        }
    };
